export default __webpack_public_path__ + "static/media/ReFLive1.07105f89.svg";